import * as React from 'react';
import * as moment from 'moment';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { history, url } from 'src';
import EventDetailPrint from 'src/components/Event/EventDetailPrint/EventDetailPrint';
import Footer from 'src/components/layout/Footer/Footer';
import CSVExport from 'src/components/utils/CSVExport/CSVExport';
import LoadingSpinner from 'src/components/utils/LoadingSpinner/LoadinSpinner';
import { renderInfo } from 'src/components/utils/Print/RenderInfo';
import PrintButton from 'src/components/utils/PrintButton/PrintButton';
import { IconPaths } from 'src/icons';
import { ApplicationState } from 'src/store';
import { deleteEvents, getEventById, hideSingleEvent } from 'src/store/events/actions';
import { Bus, CardEvent } from 'src/store/events/types';
import { User } from 'src/store/user/types';
import AddParticipant from './AddParticipant/AddParticipant';
import BusView from './BusView/BusView';
import './EventDetail.scss';
import { HiddenMessage } from './HiddenMessage/HiddenMessage';
import ParticipantsList from './ParticipantsList/ParticipantsList';
import { renderInfoPrint } from 'src/components/utils/Print/RenderInfoPrint';
import { colorError } from 'src/variables';

interface RouteProps {
  eventId: string;
}

interface PropsFromDispatch {
  getEvent: typeof getEventById;
  deleteEvents: typeof deleteEvents;
  hideSingleEvent: typeof hideSingleEvent;
}

interface PropsFromState {
  eventsById: { [id: number]: CardEvent };
  pending: boolean;
  user: User;
}

interface State {
  printing: boolean;
}

type AllProps = RouteComponentProps<RouteProps> & PropsFromDispatch & PropsFromState;

class EventDetail extends React.Component<AllProps, State> {
  eventId: string;

  constructor(props: AllProps) {
    super(props);

    this.state = {
      printing: false
    };

    if (window.matchMedia) {
      const mediaQueryList = window.matchMedia('print');
      mediaQueryList.addListener(mql => {
        if (mql.matches) {
          this.beforePrint();
        } else {
          this.afterPrint();
        }
      });
    }

    window.onbeforeprint = this.beforePrint;
    window.onafterprint = this.afterPrint;

    this.eventId = this.props.match.params.eventId;
    this.hideEvent = this.hideEvent.bind(this);
    this.unhideEvent = this.unhideEvent.bind(this);
  }

  beforePrint = () => {
    console.log('Functionality to run after printing');
    this.onPrint();
  };
  afterPrint = () => {
    console.log('Functionality to run after printing');
    this.onPrintFinished();
  };

  componentDidMount() {
    if (!isNaN(+this.eventId)) {
      this.props.getEvent(+this.eventId);
    } else {
      history.push('/404');
    }
  }

  hideEvent(event: CardEvent) {
    this.props.hideSingleEvent({ ...event, hidden: true });
  }

  unhideEvent(event: CardEvent) {
    this.props.hideSingleEvent({ ...event, hidden: false });
  }

  editEvent = () => {
    history.push(this.props.match.url + '/edit');
  };

  onPrint = () => {
    this.setState({ printing: true });
  };

  onPrintFinished = () => {
    this.setState({ printing: false });
  };

  onHideAction = (event: CardEvent, hide?: boolean) => {
    confirmAlert({
      title: 'Veranstaltung ' + (hide ? 'ausblenden' : 'einblenden'),
      message:
        'Wollen Sie nur diese oder mehrere Veranstaltungen ' +
        (hide ? 'ausblenden?' : 'einblenden?'),
      buttons: [
        {
          label: 'Einzelnes',
          onClick: () => (hide ? this.hideEvent(event) : this.unhideEvent(event))
        },
        {
          label: 'Mehrere',
          onClick: () => {
            history.push(`${this.props.match.url}/hide`);
          }
        }
      ]
    });
  };

  deleteEvent = (cardGroupId: number) => {
    confirmAlert({
      title: 'Veranstaltungen löschen',
      message: 'Wollen Sie wirklich alle Veranstaltungen dieses Typs löschen?',
      buttons: [
        {
          label: 'Löschen',
          onClick: () => this.props.deleteEvents(cardGroupId)
        },
        {
          label: 'Abbrechen',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };

  businessAllowedToRegister = (eventBegins: Date): boolean => {
    const beginmoment = moment(new Date(eventBegins).setHours(12)).subtract(1, 'day');
    const curmoment = moment(new Date());
    return curmoment.isBefore(beginmoment);
  };

  public render() {
    const { pending, eventsById, user } = this.props;

    const event: CardEvent = eventsById[this.eventId];
    // event = this.props.events.byId[this.eventId];

    return (
      <React.Fragment>
        <div className="container">
          <div className="col-lg-12 centered">
            <LoadingSpinner pending={pending} />
            {event && !this.state.printing && (
              <React.Fragment>
                {event.hidden && <HiddenMessage onClick={this.unhideEvent.bind(this, event)} />}
                {user.role.name === 'business' && !this.businessAllowedToRegister(event.begins) && (
                  <div
                    style={{
                      minHeight: '50px',
                      border: `2px solid ${colorError}`,
                      width: '100%',
                      color: colorError,
                      marginBottom: '40px'
                    }}
                  >
                    <span style={{ lineHeight: '50px' }}>
                      Gäste können nur bis 12:00 Uhr am Vortag angemeldet werden. Nach Ablauf dieser
                      Frist kontaktieren Sie die Hotline (+43 664 133 41 46).
                    </span>
                  </div>
                )}
                <div className="eventDetailHeader">
                  {user.role.canUpdateEvents && (
                    <div className="pointer" style={{ textAlign: 'left' }}>
                      <img
                        onClick={this.editEvent}
                        src={IconPaths['edit-icon']}
                        title="Bearbeiten"
                        height="25px"
                      />
                      {event.hidden ? (
                        <img
                          onClick={this.onHideAction.bind(this, event, false)}
                          src={IconPaths['show-icon']}
                          title="Einblenden"
                          height="25px"
                        />
                      ) : (
                        <img
                          onClick={this.onHideAction.bind(this, event, true)}
                          src={IconPaths['hide-icon']}
                          title="Ausblenden"
                          height="25px"
                        />
                      )}
                      {user.role.canDeleteEvents && event.eventgroup && (
                        <img
                          onClick={this.deleteEvent.bind(this, event.eventgroup.id)}
                          src={IconPaths['bin-icon']}
                          title="Löschen"
                          height="25px"
                        />
                      )}
                    </div>
                  )}
                  <h1>
                    <span>{moment(event.begins).format('DD.MM.YYYY HH:mm')}</span>
                    {user.role.canUpdateEvents && (
                      <React.Fragment>
                        <span style={{ padding: '0 0.3em' }}>|</span>
                        <span>Gruppe: {event.eventgroup && event.eventgroup.id}</span>
                      </React.Fragment>
                    )}
                    <br />
                    {event.title}
                  </h1>
                  <div className="eventInfo">
                    {event.quota !== null && (
                      <div>
                        Kontingent: <span>{event.quota} Personen</span>
                      </div>
                    )}
                    <div>
                      Teilnehmer:{' '}
                      {event.participants && <span>{event.participants.length} Personen</span>}
                    </div>
                    {event.quota !== null && (
                      <div>
                        Freie Plätze:{' '}
                        {event.participants && <span>{event.quota - event.bookedBy} Personen</span>}
                      </div>
                    )}
                  </div>
                </div>
                {user.role && user.role.canManageParticipants && (
                  <div className="row eventDetailTopSection">
                    <div className="col-12" style={{ position: 'relative', marginBottom: '20px' }}>
                      <span className="bigText border bottom">Neue Anmeldung</span>
                      <PrintButton onClick={this.onPrint} style={{ top: '-10px', right: '15px' }} />
                    </div>
                    <div className="col-lg-6 anmeldung">
                      <AddParticipant event={event} />
                    </div>
                    <div className="col-lg-6 info">{event && renderInfo(event)}</div>
                  </div>
                )}
                {/* {event.buses && event.buses.length > 0 &&} */}
                <div
                  className="border bottom"
                  style={{ position: 'relative', marginBottom: '10px' }}
                >
                  <span className="bigText">Teilnehmer</span>
                  <CSVExport event={event} style={{ top: '-8px' }} />
                </div>
                {user.role.canUpdateEvents && event.buses && event.buses.length > 0 ? (
                  this.renderBuses(event, event.buses)
                ) : (
                  <ParticipantsList
                    event={event}
                    participations={event.participants && event.participants}
                  />
                )}
                {event.image && event.image.url && (
                  <div className="row images">
                    <div className="col-lg-4">
                      <img src={url + event.image.url} style={{ width: '100%', height: 'auto' }} />
                    </div>
                    <div className="col-lg-8 eventDetailDescription">
                      {event &&
                        event.description
                          .split(/<br \/>|[\n]+/)
                          .map((item: string, key: number) => {
                            return (
                              <span key={key}>
                                {item}
                                <br />
                              </span>
                            );
                          })}
                    </div>
                  </div>
                )}
              </React.Fragment>
            )}
          </div>
        </div>
        {event && this.state.printing && (
          <EventDetailPrint
            onPrintDone={this.onPrintFinished}
            event={event}
            user={user}
            renderInfo={renderInfoPrint}
          />
        )}
        <Footer />
      </React.Fragment>
    );
  }

  renderBuses = (event: CardEvent, buses: Bus[]) => {
    buses.sort((a: Bus, b: Bus) => (a.id < b.id ? -1 : a.id > b.id ? 1 : 0));

    return <BusView buses={buses} event={event} user={this.props.user} />;
  };
}
const mapStateToProps = ({ events, auth }: ApplicationState) => ({
  eventsById: events.data.byId,
  pending: events.loading,
  user: auth.data
});

const mapDispatchToProps = (dispatch: any) => ({
  getEvent: (eventId: number) => dispatch(getEventById(eventId)),
  hideSingleEvent: (event: CardEvent) => dispatch(hideSingleEvent(event)),
  // unhideEvent: (event: CardEvent) => dispatch(unhideEvent(event)),
  deleteEvents: (cardGroupId: number) => dispatch(deleteEvents(cardGroupId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EventDetail);



// WEBPACK FOOTER //
// ./src/pages/Event/EventDetail/EventDetail.tsx